import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import {
	ProcurementFilterRequest,
	ProcurementSaveFavoriteRequest,
	GetItemsBySupplierRequest,
	GetItemsByStatusRequest,
	ChangeStatusItemsRequest,
	ProcurementProcessStatusRequest,
	GetAuditRequest,
	GetImagePartRequest,
	EditProcurementItemPriceRequest,
	ProcurementProcessStatusBulkRequest,
	OrderPrintRequest,
	RequotePartProcurementRequest,
	GetRequoteProcurementItemsRequest,
	GetPartsToReassignToBodyShopRequest,
	BulkReassignProcurementRequest,
	GetSuppliersToEvaluate,
	GetAuditByClaimRequest,
	GetBulkChangeItemsByClaimRequest,
	GetItemsBySupplierAllClaimRequest,
	PartsCancelledSearchRequest,
	ReassignPartsCancelledRequest,
	GetReassignItemsFilterRequest,
} from "@/main/models/request";
import {
	GetAuditResponse,
	GetImagePartResponse,
	GetDetailsProcurementItemPriceResponse,
	GetItemsByStatusResponse,
	GetItemsBySupplierResponse,
	ManageStatusItemsResponse,
	ProcurementHeaderViewOrderResponse,
	ProcurementViewOrderMainResponse,
	ReasignProcurementResponse,
	GetBulkChangeItemsResponse,
	OrderPrintResponse,
	GetReassignItemsResponse,
	RequoteProcurementResponse,
	ProcurementReassignToBodyShopResponse,
	SuppliersToEvaluateResponse,
	GetAuditByClaimResponse,
	PartsCancelledSearchResponse,
	GetItemsCancelledBySupplierResponse,
	ReassignBodyshopProcurementSupplierItemsResponse,
	ReassignProcurementHeaderResponse,
} from "@/main/models/response";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

export abstract class IProcurementApi {
	abstract getHeaderViewOrder(
		request: ProcurementFilterRequest,
	): Promise<AxiosResponse<Result<ProcurementHeaderViewOrderResponse>>>;
	abstract getBulkChangeItemsByClaim(
		request: GetBulkChangeItemsByClaimRequest,
	): Promise<AxiosResponse<Result<GetBulkChangeItemsResponse[]>>>;
	abstract getViewOrder(
		request: ProcurementFilterRequest,
	): Promise<AxiosResponse<Result<ProcurementViewOrderMainResponse>>>;
	abstract saveFavorite(request: ProcurementSaveFavoriteRequest): Promise<AxiosResponse<Result<void>>>;
	abstract getItemsBySupplier(
		request: GetItemsBySupplierRequest,
	): Promise<AxiosResponse<PaginationResponse<GetItemsBySupplierResponse>>>;
	abstract getItemsSupplierAllClaim(
		request: GetItemsBySupplierAllClaimRequest,
	): Promise<AxiosResponse<PaginationResponse<GetItemsBySupplierResponse[]>>>;
	abstract getItemsByStatus(
		request: GetItemsByStatusRequest,
	): Promise<AxiosResponse<Result<GetItemsByStatusResponse[]>>>;
	abstract changeStatusItems(
		request: ChangeStatusItemsRequest,
		files: File[],
	): Promise<AxiosResponse<Result<ManageStatusItemsResponse>>>;
	abstract processCancelStatus(
		request: ProcurementProcessStatusRequest,
	): Promise<AxiosResponse<Result<ManageStatusItemsResponse>>>;
	abstract processReturnStatus(
		request: ProcurementProcessStatusRequest,
	): Promise<AxiosResponse<Result<ManageStatusItemsResponse>>>;
	abstract getQuoteAuditData(request: GetAuditRequest): Promise<AxiosResponse<Result<GetAuditResponse[]>>>;
	abstract getQuoteAuditDataByClaim(
		request: GetAuditByClaimRequest,
	): Promise<AxiosResponse<Result<GetAuditByClaimResponse[]>>>;
	abstract getImagePart(request: GetImagePartRequest): Promise<AxiosResponse<Result<GetImagePartResponse[]>>>;
	abstract editProcurementItemPrice(
		request: EditProcurementItemPriceRequest,
	): Promise<AxiosResponse<Result<undefined>>>;
	abstract getDetailsProcurementItemPrice(
		guidProcurementSupplierItem: string,
	): Promise<AxiosResponse<Result<GetDetailsProcurementItemPriceResponse>>>;
	abstract getBulkChangeItems(
		procurementGuid: string,
		requestedStatus: string,
	): Promise<AxiosResponse<Result<GetBulkChangeItemsResponse>>>;
	abstract cancelBulkItems(
		request: ProcurementProcessStatusBulkRequest[],
	): Promise<AxiosResponse<Result<ManageStatusItemsResponse>>>;
	abstract returnBulkItems(
		request: ProcurementProcessStatusBulkRequest[],
	): Promise<AxiosResponse<Result<ManageStatusItemsResponse>>>;
	abstract getReassignItems(
		request: GetReassignItemsFilterRequest,
	): Promise<AxiosResponse<Result<GetReassignItemsResponse>>>;
	abstract getReassignHeader(
		guidProcurement: string | null,
		guidClaim: string | null,
	): Promise<AxiosResponse<Result<ReassignProcurementHeaderResponse>>>;
	abstract orderPrint(request: OrderPrintRequest): Promise<AxiosResponse<Result<OrderPrintResponse>>>;
	abstract requotePartProcurement(request: RequotePartProcurementRequest): Promise<AxiosResponse<Result<any>>>;
	abstract getRequoteProcurementItems(
		request: GetRequoteProcurementItemsRequest,
	): Promise<AxiosResponse<Result<RequoteProcurementResponse>>>;
	abstract getPartsToReassignToBodyShop(
		request: GetPartsToReassignToBodyShopRequest,
	): Promise<AxiosResponse<Result<ProcurementReassignToBodyShopResponse[]>>>;
	abstract reassignToBodyShop(
		request: BulkReassignProcurementRequest,
	): Promise<AxiosResponse<Result<ReasignProcurementResponse>>>;
	abstract getSuppliersToEvaluate(
		request: GetSuppliersToEvaluate,
	): Promise<AxiosResponse<Result<SuppliersToEvaluateResponse[]>>>;
	abstract reopenPart(request: string): Promise<AxiosResponse<Result<ManageStatusItemsResponse>>>;
	abstract getPartsCancelled(
		request: PartsCancelledSearchRequest,
	): Promise<AxiosResponse<PaginationResponse<PartsCancelledSearchResponse>>>;
	abstract getItemsCancelledBySupplierDetails(
		guidParts: string[],
	): Promise<AxiosResponse<Result<GetItemsCancelledBySupplierResponse[]>>>;
	abstract reassignPartsCancelledBySupplier(
		request: ReassignPartsCancelledRequest[],
	): Promise<AxiosResponse<Result<boolean>>>;
	abstract reassignToBodyshopProcurementSupplierItems(
		request: ReassignPartsCancelledRequest[],
	): Promise<AxiosResponse<Result<ReassignBodyshopProcurementSupplierItemsResponse>>>;
}
